module.exports = fox._r("images/pc.png", __webpack_public_path__ + "images/pc.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/pc.png
// module id = 1090
// module chunks = 4